export const valid = {
  valid: true,
  message: "",
};

export const isRequired = (value = "") => {
  if ([ "", null, undefined ].includes(value)) {
    return {
      valid: false,
      message: "This field is required",
    };
  }
  return valid;
};

export const atLeast = (minimum) => (value = []) => {
  if (value?.length < minimum) {
    return {
      valid: false,
      message: `This field should contains at least ${minimum} item(s)`,
    };
  }
  return valid;
};

export const uniquePaymentTypes = (value = []) => {
  if (value.length !== new Set(value?.map?.(x=>`${x.paymentType.id}_${x.externalAccountId}`)).size){
    return {
      valid: false,
      message: `This field should contains unique payment type and account pairs`,
    };
  }
  return valid;
};

export const isPhoneValid = (value = {}) => {
  if (!value?.countryCode) {
    return {
      valid: false,
      message: `Country code is required`,
    };
  }
  if (!value?.phone) {
    return {
      valid: false,
      message: `Phone is required`,
    };
  }
  if (value.countryCode.digits.every(x => value.phone.length !== x)) {
    return {
      valid: false,
      message: `Phone should contains ${value.countryCode.digits.join(" or ")} numbers`,
    };
  }
  return valid;
};


export const validateInnerFields = (validations=[], field) => (value = []) => {
  let errors = value.reduce((acc,item,index)=>{
    const validationResult = validateValues(item, validations);
    return validationResult ? {
      ...acc,
      [index]: validationResult,
    } : acc;
  },{});

  if (!Object.keys(errors).length) {
    return null;
  }

  return errors;
};


export const validateField = (values, field, ...validations) => {
  let error = null;
  for (const validation of validations) {
    const validationResult = validation(values[field], field);
    if (validationResult && !validationResult.valid) {
      const {valid,message, ...restErrors} = validationResult;
      return {
        [field]: Array.isArray(values[field]) ? {
          ...restErrors,
          _error: validationResult.message,
        } : validationResult.message,
      };
    }
  }

  return error;
};

export const validateValues = (values, validations) => {
  const errors = Object.entries(validations)
    .reduce((errors, [ key, validators ]) => ({
      ...errors,
      ...validateField(values, key, ...validators),
    }), {});

  if (!Object.keys(errors).length) {
    return null;
  }
  return errors;
};
